import React from "react";
import LinkedinIcon from "./icons/linkedin.svg";
import FacebookIcon from "./icons/facebook.svg";
import XIcon from "./icons/x.svg";
import YoutubeIcon from "./icons/youtube.svg";
import { rootUrl } from "@bundles/consts";

export const HOMEPAGE_URL = process.env.WORDPRESS_DOMAIN;

export const socialMediaLinks = [
  {
    icon: <LinkedinIcon />,
    alt: "LinkedIn",
    url: "https://www.linkedin.com/company/bnktothefuture/",
  },
  {
    icon: <FacebookIcon />,
    alt: "Facebook",
    url: "https://www.facebook.com/banktothefuture",
  },
  {
    icon: <XIcon />,
    alt: "X",
    url: "https://x.com/banktothefuture",
  },
  {
    icon: <YoutubeIcon />,
    alt: "YouTube",
    url: "https://www.youtube.com/user/BankToTheFuture",
  },
];

export const getExploreLinks = (_isUk?: boolean, isUkRestricted?: boolean) => {
  const sections = [
    {
      label: "Private Equity Markets",
      url: "/market/spvs",
    },
    {
      label: "Portfolio Company Directory",
      url: "/companies",
    },
    {
      label: "Fees",
      url: `${HOMEPAGE_URL}/fees`,
    },
    {
      label: "Careers",
      url: `${HOMEPAGE_URL}/careers`,
    },
    {
      label: "About us",
      url: `${HOMEPAGE_URL}/about`,
    },
  ];

  if (isUkRestricted) {
    return sections.slice(3);
  }

  return sections;
};

export const unsignedUkExploreLinks = [
  {
    label: "Private Equity Pitch Archives",
    url: "/search/pitches",
  },
  {
    label: "Portfolio Company Directory",
    url: "/companies",
  },
  {
    label: "Fees",
    url: `${HOMEPAGE_URL}/fees`,
  },
  {
    label: "Careers",
    url: `${HOMEPAGE_URL}/careers`,
  },
  {
    label: "About us",
    url: `${HOMEPAGE_URL}/about`,
  },
];

export const legalLinks = [
  {
    label: "Terms & conditions",
    url: "/terms_and_conditions",
  },
  {
    label: "Risk Warnings",
    url: `${HOMEPAGE_URL}/risk-warnings`,
  },
  {
    label: "Privacy",
    url: `${HOMEPAGE_URL}/privacy-cookies`,
  },
];

export const textAboveDivider = [
  {
    prefix: "Ownership and Operation:",
    content:
      "This website (the 'Website') is owned and operated by BNK To The Future ('BF'), a company incorporated in the Cayman Islands under the Companies Act (as revised) with Company Number 296093. BF is registered with the Cayman Islands Monetary Authority (CIMA) under the Securities Investment Business Act (as revised) with CIMA Number 1601784.",
  },
  {
    prefix: "Securities Brokerage Activities:",
    content:
      "Platform Operator and Broker: BF acts as the Platform Operator for the BF Platform and the BF Securities Broker for unlisted shares. BF is registered with CIMA under the Securities Investment Business Act (as revised) with CIMA Number 1601784.",
  },
  {
    prefix: "Unlisted Securities:",
    content:
      "The BF Securities Broker facilitates arrangements for High Net Worth investors (as defined by Cayman Islands regulations) to invest in unlisted/private shares held by the BF Platform Company, which is BNK To The Future Capital SPC, a Cayman Islands exempted segregated portfolio company with registered number 298427.",
  },
  {
    prefix: "Listed Securities:",
    content:
      ' Arrangements for investments in listed securities are conducted by BF Global MU (the "Public Shares BF Securities Broker"). The Public Shares Securities Broker is a private company limited by shares incorporated in Mauritius under Mauritian law with Company Number 197710 GBC. It is licensed by the FSC as a Global Business Company with a Global Business License (GB22201273 (Code FS - 4.1)) and an Investment Dealer (Broker) License (GB22201273 (Sec -2.1B)) issued on June 8th, 2023.',
  },
  {
    prefix: "Investor Eligibility:",
    content:
      "Unlisted securities brokerage services are intended solely for investors who qualify as 'High Net Worth' under Cayman Islands regulations. Registration on the Website does not automatically qualify you as a High Net Worth Investor.",
  },
  {
    prefix: "Virtual Asset Services:",
    content:
      "BF Virtual Assets Ltd ('BFVA'), a company incorporated in the British Virgin Islands with company number 2096766, acts as the BF Virtual Assets Broker on the BF Platform. BFVA provides custody and trading services in relation to virtual assets under the Virtual Assets Service Providers Act 2022 and is pending registration as a Virtual Asset Service Provider (VASP) with the BVI Financial Services Commission.",
  },
];

export const textBelowDivider = [
  {
    prefix: "Risk Factors:",
    content:
      "Investing in private placements, cryptocurrencies, security tokens, and early-stage businesses involves significant risks, including, but not limited to, illiquidity, lack of dividends, loss of investment and dilution, regulatory and tax uncertainty, cyber-security attacks, blockchain risks, and lack of shareholder rights. Investors who cannot afford to lose their entire investment should not participate.",
  },
  {
    prefix: "Disclaimer of Warranties and Guarantees:",
    content:
      "Investments may lose value. Neither the BF Platform nor its affiliated companies offer investment, legal, or tax advice. Securities and investments are not FDIC insured.",
  },
  {
    prefix: "Affiliated Companies:",
    content:
      "Certain activities on the Website may involve engagements with other BF affiliated companies, including Bnk To The Future Capital SPC (company number 298427) and BF Portfolio Builder SPC (company number 372663), both incorporated and registered in the Cayman Islands.",
  },
  {
    prefix: "US Residents:",
    content:
      "Effective February 11, 2023, new accounts on the BF Platform are not available to US residents. Existing US resident account holders may access their account records but cannot participate in any primary market offering by Investee Entities provided by a US Broker Member on the Platform.",
  },
  {
    prefix: "Regulatory Compliance:",
    content:
      "Individuals and firms accessing the Website must comply with all applicable licensing and qualification requirements in their jurisdictions.",
  },
];

export const bottomText = [
  {
    prefix: "Information and Disclaimer:",
    content:
      "The information provided on the Website is for informational purposes only and does not constitute professional advice. The Platform Operator encourages Users to seek independent professional advice before making any investment decisions. Neither the Platform Operator nor its affiliates are liable for any losses incurred due to reliance on such information.",
  },
  {
    prefix: "Terms and Conditions:",
    content: (
      <>
        By accessing the Website, you agree to the Bnk To The Future&nbsp;
        <a className="underline" href="/terms_and_conditions" target="_blank">
          Terms & Conditions
        </a>
        ,&nbsp;
        <a
          className="underline"
          href={`${HOMEPAGE_URL}/risk-warnings`}
          target="_blank"
        >
          Risk Warnings
        </a>
        ,&nbsp;
        <a className="underline" href="#">
          Disclaimers
        </a>
        ,&nbsp;and&nbsp;
        <a
          className="underline"
          href={`${HOMEPAGE_URL}/privacy-cookies`}
          target="_blank"
        >
          Privacy Policy
        </a>
        .
      </>
    ),
  },
  {
    prefix: "Trademark:",
    content:
      "BnkToTheFuture.com is a registered trademark owned by BF Global and its trading group.",
  },
  {
    prefix: "Website Availability:",
    content:
      "The Platform Operator does not guarantee uninterrupted access to the Website and accepts no liability for any service interruptions or outages. The Platform Operator may take the Website offline for maintenance or upgrades with or without prior notice.",
  },
];
export const getUkProductSections = (profileSlug: string) => [
  {
    title: "Build Your Bitcoin Wealth",
    titleBackground: "bg-primary-regular",
    links: [
      {
        label: "Buy Bitcoin",
        icon: "/build-wealth-icon.svg",
        url: `${rootUrl}${profileSlug}/funds/manage/buy?currency=btc`,
      },
      {
        label: "Stake ETH",
        icon: "/build-wealth-icon.svg",
        url: `${rootUrl}${profileSlug}/funds/stakingEth`,
      },
      {
        label: "Convert Fiat to Stablecoins",
        icon: "/build-wealth-icon.svg",
        url: `${rootUrl}${profileSlug}/funds/manage/deposit?currency=bfusd`,
      },
    ],
  },
  {
    title: "Manage your bitcoin wealth",
    titleBackground: "bg-primary-dark",
    links: [
      {
        label: "Bitcoin Financial Planning",
        icon: "/build-protect-icon.svg",
        url: "https://www.bitcoinwealthbuilder.io/bwb ",
      },
      {
        label: "Bitcoin Tax Technology",
        icon: "/build-protect-icon.svg",
        url: "https://www.bitcoinwealthbuilder.io/bwb ",
      },
      {
        label: "Bitcoin Inheritance Technology",
        icon: "/build-protect-icon.svg",
        url: "https://www.bitcoinwealthbuilder.io/bwb ",
      },
    ],
  },
];

export const getProductsSections = (profileSlug: string) => [
  {
    title: "Build Your Bitcoin Wealth",
    titleBackground: "bg-primary-regular",
    links: [
      {
        label: "Buy Bitcoin & Stake ETH",
        icon: "/build-wealth-icon.svg",
        url: `${profileSlug}/funds/myFunds`,
      },
      {
        label: "Invest in Bitcoin Public Shares",
        icon: "/build-wealth-icon.svg",
        url: `${profileSlug}/shares/public-equity`,
      },
      {
        label: "Invest in Bitcoin Private Equity",
        icon: "/build-wealth-icon.svg",
        url: "/market/spvs",
      },
    ],
  },
  {
    title: "Protect Your Bitcoin Wealth",
    titleBackground: "bg-primary-dark",
    links: [
      {
        label: "Bitcoin Financial Planning",
        icon: "/build-protect-icon.svg",
        url: "https://www.simondixon.com/bwb",
      },
      {
        label: "Bitcoin Tax Technology",
        icon: "/build-protect-icon.svg",
        url: "https://www.simondixon.com/bwb",
      },
      {
        label: "Bitcoin Inheritance Technology",
        icon: "/build-protect-icon.svg",
        url: "https://www.simondixon.com/bwb",
      },
    ],
  },
];
